$('.main-menu').find('.main-menu__item-sub').last().addClass('main-menu__item-sub_last')

$('.main-header__button').click(function() {
    if ($(this).hasClass('active')) {
        closeMainMenu()
        closeMainSubmenu()
    } else {
        openMainMenu()
    }
})

$('.main-menu__button').click(function() {
    if ($(this).hasClass('active')) {
        closeMainSubmenu()
    } else {
        let isActive = false 
        $('.main-submenu').each((i, el) => {
            $(el).hasClass('active') ? isActive = true : ''
        })
        if (isActive) {
            closeMainSubmenu(true)
            setTimeout(() => {
                openMainSubmenu($(this))
            }, 300)
        } else {
            openMainSubmenu($(this))
        }
    }
})

$('.main-submenu__close').click(function() {
    closeMainSubmenu(false, true)
})

$('.js_footer-main__header-open').on('click', function() {
    let targetName = $(this).data('target')
    let target = $(`.js_main-menu__button[data-target="${targetName}"]`)
    openMainMenu()
    openMainSubmenu(target)
})

whiteHeaderMobile()
$(window).on('resize', function() {
    whiteHeaderMobile()
})

function openMainMenu() {
    $('.main-header').addClass('active')
    $('.main-header__button').addClass('active')
    $('.main-header__visible').addClass('active')
    $('.main-header__closed').addClass('active')
    $('.main-header__links').addClass('active')
    $('.main__header').addClass('active')
    $('.footer-main').addClass('active')
    let count = 0
    $('.main-menu__item').each((i, el) => {
        setTimeout(() => {
            $(el).addClass('active')
        }, count)
        count += 200
    })
    $('.main-langs__item').each((i, el) => {
        setTimeout(() => {
            $(el).addClass('active')
        }, count)
        count += 200
    })
    $('body').css('overflow', 'hidden')
}

function closeMainMenu() {
    $('.main-header').removeClass('active')
    $('.main-header__button').removeClass('active')
    $('.main-header__visible').removeClass('active')
    $('.main-header__closed').removeClass('active')
    $('.main-header__links').removeClass('active')
    $('.main__header').removeClass('active')
    $('.footer-main').removeClass('active')
    $('.main-menu__item').removeClass('active')
    $('.main-langs__item').removeClass('active')
    $('body').removeAttr('style')
}

function openMainSubmenu(target) {
    target.addClass('active')
    $('.main-header__menu').addClass('active')
    let submenu = target.next('.main-submenu').addClass('active')
    let count = 1000
    submenu.find('.main-submenu__item').each((i, el) => {
        setTimeout(() => {
            $(el).addClass('active')
        }, count)
        count += 200
    })
    count += 500 
    setTimeout(() => {
        $('.main-menu__line').addClass('active')
    }, count)
}

function closeMainSubmenu(isActive, isTablet) {
    if (isTablet) {
        $('.main-menu__line').removeClass('active')
        $('.main-submenu__item').removeClass('active')
        $('.main-submenu').removeClass('active')
        $('.main-menu__button').removeClass('active')
        setTimeout(() => {
            !isActive ? $('.main-header__menu').removeClass('active') : ''
        }, 500)
    } else {
        $('.main-submenu__item').removeClass('active')
        setTimeout(() => {
            $('.main-submenu').removeClass('active')
            $('.main-menu__line').removeClass('active')
            $('.main-menu__button').removeClass('active')
        }, 200)
        !isActive ? $('.main-header__menu').removeClass('active') : ''
    }
}

function whiteHeaderMobile() {
    if ($(window).outerWidth() < 568) {
        $('.js__portfolio-header').addClass('header_white')
        $('.js__portfolio-header').removeClass('color-mix')
    } else {
        $('.js__portfolio-header').removeClass('header_white')
        $('.js__portfolio-header').addClass('color-mix')
    }
}